import { api } from '@shared/api';
import type { Level, Role } from '@shared/types';

export type PaceLearning = 'Low' | 'Medium' | 'High';
export type InterfaceLanguage = 'English' | 'Russian';

export interface ProfileUserBrief {
  email: string;
  name: string;
  is_email_verified: boolean;
  /** Поддерживал ли проект донатом (для плашки «Поддержал проект»). snake_case,
   *  как is_email_verified — не трогается трансформером. */
  has_donated: boolean;
}

export interface Profile {
  user: ProfileUserBrief;
  english_level: Level;
  pace_learning: PaceLearning;
  target_cards_per_day: number;
  new_cards_per_session: number;
  is_sound_active: boolean;
  is_notification: boolean;
  /** Час напоминаний по МСК (7–22), выбранный на итоге знакомства; null — 19:00. У старого бэка нет. */
  reminder_hour?: number | null;
  /** Автопереход к следующей карточке после верного ответа. По умолчанию false.
   *  snake_case — как is_notification, не трогается camel/snake-трансформером. */
  auto_advance: boolean;
  language_interface: InterfaceLanguage;
  completed_onboarding: boolean;
  /** Роль аккаунта. `role` — одно слово, поэтому camel/snake-трансформеры его не
   *  трогают, ключ совпадает на бэке и фронте. */
  role: Role;
  /** Как у ученика с английским — спрашивает игра (2026-10-25); null — ещё не спрашивали. */
  learner_level?: 'zero' | 'basic' | 'confident' | null;
  /** Почта не подтверждена, а бесплатная своя карточка ещё не потрачена (2026-11-02). У старого бэка нет. */
  guest_card_available?: boolean;
}

export async function fetchProfile(): Promise<Profile> {
  const { data } = await api.get<Profile>('/profile');
  return data;
}

/** Частичное обновление профиля. Ключи — snake_case (как принимает бэк;
 *  request-тела не проходят camel→snake-трансформер, см. finish-onboarding). */
export interface UpdateProfilePayload {
  name?: string;
  english_level?: Level;
  target_cards_per_day?: number;
  new_cards_per_session?: number;
  language_interface?: InterfaceLanguage;
  auto_advance?: boolean;
  /** Напоминания на почту (A). У всех по умолчанию true; false — отписка, как по ссылке из письма. */
  is_notification?: boolean;
  /** Час напоминаний по МСК (7–22); явный null — сброс к 19:00. Итог знакомства после раннего завершения (B5). */
  reminder_hour?: number | null;
  learner_level?: 'zero' | 'basic' | 'confident';
}

export async function updateProfile(payload: UpdateProfilePayload): Promise<Profile> {
  const { data } = await api.put<Profile>('/profile', payload);
  return data;
}
